import React, { useEffect, useRef } from "react";
import styles from "./mailerLiteForm.module.css";

const MailerLiteForm = ({ id }) => {
  const myElementRef = useRef(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.style.display = "block";
        const formSubmit = element.querySelector(".ml-form-embedSubmit");
        if (formSubmit) {
          const button = formSubmit.querySelector("button.primary");
          if (button) {
            button.style.fontFamily = "var(--font-family-inter), sans-serif !important";
          }
        }
        myElementRef.current.appendChild(element);
      }
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, []);

  return <div className={styles.mailerLiteForm} ref={myElementRef} />;
};

export default MailerLiteForm;
